var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._g(_vm._b({attrs:{"dense":"","outlined":"","items":_vm.items,"item-text":"value","item-value":"id","hide-details":"auto","clearable":""}},'v-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }